export const LOCATION_KEY = 'clientLocation';

export const GET_CLIENT_LOCATION_REQUEST =
  'location/GET_CLIENT_LOCATION_REQUEST';
export const GET_CLIENT_LOCATION_SUCCESS =
  'location/GET_CLIENT_LOCATION_SUCCESS';
export const GET_CLIENT_LOCATION_FAILURE =
  'location/GET_CLIENT_LOCATION_FAILURE';
